import fetchJSON from '@api/api_helper';
import { processAnnotationResponse } from '@api/helper';

const getUrl = (versionKey) => `/api/v4/versions/${versionKey}/annotations`;


export const get = (options, updateFetchControllers) => (
  fetchJSON(getUrl(options.versionKey), options, updateFetchControllers)
    .then((response) => processAnnotationResponse(response))
);

export const post = (options, updateFetchControllers) => {
  const { note, parent_id, versionKey, mentionedUsers, x_offset_in_percentage, y_offset_in_percentage } = options;
  const url = getUrl(versionKey);

  const data = {
    note,
    ...x_offset_in_percentage && { x_offset_in_percentage },
    ...y_offset_in_percentage && { y_offset_in_percentage },
    ...parent_id && { parent_id },
    ...mentionedUsers && { mentioned_users: mentionedUsers }
  };

  const appendedOptions = {
    body: { data: { attributes: data } },
    method: 'POST'
  };

  if (options.params) {
    appendedOptions.params = options.params;
  }

  return fetchJSON(url, appendedOptions, updateFetchControllers)
    .then((response) => processAnnotationResponse(response));
};
